import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async () => {
  const keycloak = inject(KeycloakService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLoggedIn = await keycloak.isLoggedIn();
  if (!isLoggedIn) {
    await keycloak.login();
    return false;
  }

  if (!authService.isImpersonated() && !authService.hasRole('feat-labs-preisradar')) {
    return router.createUrlTree(['/zugang-gesperrt']);
  }

  return true;
};
